<template>
    <div class="contents">
        <i class="icon-chevron-down"></i>
        <ul class="cart-items">
            <li v-for="item in items" :key="item.id">
                <i class="icon-close pull-right" @click="removeItem(item.id)"></i>
                {{ item.name }}
                <div class="row">
                    <div class="col align-self-end">
                        <img :src="item.image" alt=""/>
                    </div>
                    <div class="col align-self-end">{{ formatQuantity(item) }} {{ item.unit }}</div>
                    <div class="col align-self-end">{{ item.price | money }}/{{ item.unit }}</div>
                </div>
            </li>
            <li class="total">Skupaj: <span class="pull-right">{{ total | money }}</span></li>
        </ul>
        <a href="" class="btn btn-outline-green">OGLED KOŠARICE</a>
    </div>
</template>

<script>
export default {
  
  props: {
      items: {
          default: []
      },
      src: {
          default: '/cart',
          required: true,
          type: String
      }
  },

  computed: {

      total() {
          return this.items.reduce((accumulator, current) => accumulator + parseFloat(current.quantity) * parseFloat(current.price), 0)
      }
  },

  methods: {

      formatQuantity(item) {
          return item.unit == 'm' ? parseFloat(item.quantity).toFixed(1).replace('.', ',') : parseInt(item.quantity)
      },

      removeItem(id) {
          new App.xhr({id}).delete(this.src).then(({items}) => {
              App.dispatcher.fire(App.event.CART_UPDATED, items);
          })
      }

  },

  filters: {

      money(value) {
          return parseFloat(value).toLocaleString('sl-SI') + ' €'
      }
  }

}
</script>
